import { render } from "./FPrintTable.vue?vue&type=template&id=3daa160a"
import script from "./FPrintTable.vue?vue&type=script&lang=js"
export * from "./FPrintTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__